import { BOX_SLOT_PARTICIPANTS_LIMIT_MAX, BOX_SLOT_PARTICIPANTS_LIMIT_MIN } from "@modules/boxSlot/boxSlotTypes"
import { word } from "@modules/core/utils/i18n"
import { requiredInput } from "@modules/form/formUtils"
import dayjs from "dayjs"
import * as Yup from "yup"

export type BoxSlotTemplateInputKey =
  | "weekDay"
  | "startDateTime"
  | "endDateTime"
  | "sessionId"
  | "participantLimit"
  | "limitStart"
  | "limitEnd"
  | "limitCancel"
  | "location"
  | "allowMultiBooking"
  | "assignedStaffMembers"
  | "dropinsAccepted"
  | "trialsAccepted"

export function getValidationSchema(isEdition: boolean) {
  return Yup.object({
    weekDay: requiredInput(Yup.string().trim()),
    startDateTime: Yup.date()
      .required(word("global.form.required"))
      .test(
        "startDateTime",
        word("box.slotTemplateGroup.form.registration.end_error"),
        (value, { parent: { endDateTime } }) => {
          return value !== null && value !== undefined && dayjs(value).isBefore(endDateTime)
        },
      ),
    endDateTime: Yup.date()
      .required(word("global.form.required"))
      .test(
        "endDateTime",
        word("box.slotTemplateGroup.form.registration.end_error"),
        (value, { parent: { startDateTime } }) => {
          return value !== null && value !== undefined && dayjs(value).isAfter(startDateTime)
        },
      ),
    participantLimit: Yup.number()
      .required(word("global.form.required"))
      .min(
        BOX_SLOT_PARTICIPANTS_LIMIT_MIN,
        word("global.form.minimumValue", { minValue: BOX_SLOT_PARTICIPANTS_LIMIT_MIN }),
      )
      .max(
        BOX_SLOT_PARTICIPANTS_LIMIT_MAX,
        word("global.form.maximumValue", { maxValue: BOX_SLOT_PARTICIPANTS_LIMIT_MAX }),
      ),
    location: Yup.string()
      .trim()
      .nullable()
      .max(40, word("form.maximum.characters", { count: 40 })),
    limitStart: Yup.number()
      .min(1, word("global.form.minimumValue", { minValue: 1 }))
      .required(word("global.form.required")),
    limitEnd: Yup.number()
      .min(1, word("global.form.minimumValue", { minValue: 1 }))
      .test("limitEnd", word("box.slotTemplateGroup.form.registration.end_error"), (value, context) => {
        return context.parent.limitStart !== null && !!value && context.parent.limitStart > value
      }),
    limitCancel: Yup.number()
      .min(1, word("global.form.minimumValue", { minValue: 1 }))
      .required(word("global.form.required")),
    allowMultiBooking: Yup.boolean().nullable(),
    impactAlreadyCreatedSlot: isEdition ? Yup.boolean().required() : Yup.boolean().nullable(),
    assignedStaffMembers: Yup.array(),
    dropinsAccepted: Yup.boolean().nullable(),
    trialsAccepted: Yup.boolean().nullable(),
  })
}
